import styled, { css } from 'styled-components';
import { colors, th } from 'style/theme';

export const CheckBox = styled.input`
  margin: 8px 0 0 0;
`;

export const ErrorMessage = styled.span`
  margin-left: 5px;
  color: ${th('colors.red')};
  font-weight: 700;
  font-size: 14px;
`;

export const NewInputStyle = css`
  background: ${colors.pickledBluewood4};
  border-radius: 16px;
  padding: 8px 14px;

  > input {
    font-family: 'Helvetica Now';
    font-style: normal;
    color: ${colors.pickledBluewood};
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    margin: 0;
    padding: 0;
    border: none;
  }

  > label {
    font-family: 'Helvetica Now';
    color: ${colors.pickledBluewood2};
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;

    > svg {
      display: none;
    }

    > span {
      font-size: 12px;
    }
  }
`;
